import { BaseModel } from "./BaseModel";

export class CommandModel extends BaseModel {

}
